(function () {
  async function init() {
    var root = document.querySelector('.zlj[data-journal-source-pages]');
    if (!root || root.dataset.pagesReady) return;
    root.dataset.pagesReady = 'loading';
    var grid = root.querySelector('.zlj__grid');
    var media = window.matchMedia('(min-width: 990px)');
    var requested = Math.max(1, parseInt(new URL(location.href).searchParams.get('journal_page'), 10) || 1);
    var sourcePage = Number(root.dataset.journalSourcePage);
    var sourcePages = Number(root.dataset.journalSourcePages);
    var cards = [];
    try {
      // Read all Shopify batches before applying device-specific page sizes.
      // On failure retain the server-rendered list and native pagination.
      for (var batch = 1; batch <= sourcePages; batch++) {
        var sourceRoot = root;
        if (batch !== sourcePage) {
          var url = new URL(location.href); url.searchParams.delete('journal_page'); url.searchParams.set('page', batch);
          var response = await fetch(url.href, {credentials: 'same-origin'});
          if (!response.ok) throw new Error('Journal batch unavailable');
          sourceRoot = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('.zlj[data-journal-source-pages]');
          if (!sourceRoot) throw new Error('Journal list unavailable');
        }
        cards.push.apply(cards, Array.from(sourceRoot.querySelectorAll('.zlj__grid > .zlj-card')));
      }
    } catch (error) { delete root.dataset.pagesReady; return; }
    var nav = root.querySelector('.zlj-pagination');
    if (!nav) { nav = document.createElement('nav'); nav.className = 'zlj-pagination'; nav.setAttribute('aria-label', 'Journal pages'); grid.after(nav); }
    var page = requested;
    function countPages() { return media.matches ? 1 + Math.ceil(Math.max(0, cards.length - 31) / 30) : Math.max(1, Math.ceil(cards.length / 10)); }
    function startIndex() { return media.matches ? (page === 1 ? 0 : 31 + (page - 2) * 30) : (page - 1) * 10; }
    function pageUrl(number) { var url = new URL(location.href); url.searchParams.delete('page'); if (number === 1) url.searchParams.delete('journal_page'); else url.searchParams.set('journal_page', number); return url.pathname + url.search + url.hash; }
    function render() {
      var pages = countPages(); page = Math.min(pages, Math.max(1, page));
      var start = startIndex(), size = media.matches ? (page === 1 ? 31 : 30) : 10;
      grid.replaceChildren();
      cards.slice(start, start + size).forEach(function(card, index) {
        card.hidden = false;
        card.classList.toggle('zlj-card--featured', page === 1 && index === 0);
        grid.appendChild(card);
      });
      nav.replaceChildren(); nav.hidden = pages <= 1;
      function link(label, target, rel) {
        var node = document.createElement(target === page && !rel ? 'span' : 'a');
        node.textContent = label;
        if (node.tagName === 'A') {
          node.href = pageUrl(target); if (rel) node.rel = rel;
          node.addEventListener('click', function(event) {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
            event.preventDefault(); page = target; history.pushState(null, '', pageUrl(page)); render();
            root.scrollIntoView({block: 'start'});
          });
        } else node.setAttribute('aria-current', 'page');
        nav.appendChild(node);
      }
      if (page > 1) link('Previous', page - 1, 'prev');
      for (var i = 1; i <= pages; i++) link(String(i), i);
      if (page < pages) link('Next', page + 1, 'next');
    }
    render(); root.dataset.pagesReady = 'true';
    media.addEventListener('change', function() { page = 1; history.replaceState(null, '', pageUrl(page)); render(); });
    window.addEventListener('popstate', function() { page = Math.max(1, parseInt(new URL(location.href).searchParams.get('journal_page'), 10) || 1); render(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
